"use client";

import Link from "next/link";
import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import { ArrowRight } from "@/components/icons";
import { ROUTES } from "@/lib/constants";
import { ALTERNATIVE_CARDS } from "@/components/sections/editorial/alternatives/archive/data";

// German clone of src/components/sections/products/shared/compare-alternatives
// — competitor names and comparison-page hrefs stay as-is (those pages are
// English-only), only the surrounding copy is translated.

const MotionDiv = motion.div;

const VISIBLE_ALTERNATIVES = 7;

export default function CompareAlternativesDe() {
  const prefersReducedMotion = useReducedMotion();
  const visibleCards = ALTERNATIVE_CARDS.slice(0, VISIBLE_ALTERNATIVES);

  return (
    <section
      className="full-bleed band-wash border-border border-b py-16"
      aria-labelledby="compare-alternatives-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <MotionDiv
          initial={prefersReducedMotion ? {} : { opacity: 0, y: 20 }}
          whileInView={prefersReducedMotion ? {} : { opacity: 1, y: 0 }}
          viewport={scrollRevealViewport}
          transition={{ duration: 0.5 }}
          className="border-border bg-card flex flex-col gap-4 rounded-xl border p-6 sm:flex-row sm:items-center sm:justify-between"
        >
          <div>
            <h2
              id="compare-alternatives-heading"
              className="text-foreground text-base font-semibold"
            >
              Anbieter vergleichen?
            </h2>
            <p className="text-muted-foreground mt-1 text-sm">
              Transparente Preisvergleiche gegenüber {ALTERNATIVE_CARDS.length} weiteren
              Proxy-Anbietern.
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {visibleCards.map((card) => (
              <Link
                key={card.href}
                href={card.href}
                className="border-border text-foreground hover:border-brand/40 hover:bg-brand/5 inline-flex items-center rounded-full border px-3 py-1.5 text-xs font-medium transition-colors"
              >
                vs {card.competitor}
              </Link>
            ))}
            <Link
              href={ROUTES.alternatives}
              className="text-brand hover:text-brand/80 inline-flex items-center gap-1 text-xs font-semibold"
            >
              Alle Vergleiche
              <ArrowRight size={12} aria-hidden="true" />
            </Link>
          </div>
        </MotionDiv>
      </div>
    </section>
  );
}
